import { IApiThread, IThread } from './thread.types';

export const threadSerializer = ({
  id,
  relationships: { lastMessage, mainPicture, otherMember },
}: IApiThread): IThread => ({
  id,
  relationships: {
    accountId: otherMember.data.id,
    threadMainPicture: mainPicture?.data?.id,
    messages: {
      list: [lastMessage.data.id],
      meta: {},
    },
  },
  permissions: {},
});
